import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { Text } from '@vds/core';
import styled from 'styled-components';
import {
  ChatLink,
  CustomBreadcrumb,
  SearchInput,
  ContactSales,
} from "../../../../common/components";
import { MarginSpacerM } from "common/components/styleTag";
import PromoHeader from "pages/Byod/components/PromoHeader/PromoHeader";
import { useSelector } from "react-redux";
import { Notification } from "@vds/notifications";
import { VZStepper } from "common/components/HorizontalProgress/VZStepper";
import { HeroCopy } from "../../../../common/components";
import { TitleLockup } from "@vds3/type-lockups";

const GridWallHeaderContainer = styled.div`
 width:100%;
 padding:10px;
 `;

 const TitleWrapper =styled.div`
 h1{
 color:#E10014
 }
 `
const GridwallHeader = ({
  currentPath,
  metaInformation,
  isOneTalk,
  is5gsmartphones,
  isSearchLayout,
  isTabLayout,
  totalResults,
  searchValue,
  setSearchValue,
  fetchNextItems,
  toggleFilters,
  setshowCartDetailsModal,
  showCartDetailsModal,
  isBogo,
  hideBreadcrumbs,
  ...props
}) => {
  const { t } = useTranslation(["gridwall", "app"]);
  const isMobile = useMediaQuery({
    query: "(max-width: 545px)",
  });
  const isDesktop = useMediaQuery({
    query: "(min-width: 768px)",
  });
  const isDesktopBanner = useMediaQuery({
    query: "(min-device-width: 1200px)",
  });
  const isLaptop = useMediaQuery({
    query: "(min-device-width: 1024px)",
  });

  const gridWallBanner = t("gridwall.gridWallBanner", { ns: "gridwall", returnObjects: true });
  const isPortrait = useMediaQuery({ orientation: 'portrait' });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1024 });
  const globalData = useSelector((state) => state.GlobalData);
  const pageData = useSelector((state) => state.MobilityPage);
  const landing4gData = useSelector((state) => state.Landing4GPage);
  const isLaptopByod = window?.location?.pathname?.includes("laptops");
  const enableBanner = t("gridwall.enableBanner", { ns: "gridwall" });
  const [showBundleNotification, setShowBundleNotification] = useState("");
  const showBuyNowFlow = t("gridwall.enableBuyNowFlow", { ns: "gridwall" });


  const [showSearch, setShowSearch] = useState(true);
  useEffect(() => {
    if (window?.location?.pathname?.includes("basic-phones") || window?.location?.pathname?.includes("mobile-hotspots")) {
      setShowSearch(false);
    }
  }, [])

  useEffect(() => {
    if (pageData?.bundleOfferSelected) {
      setShowBundleNotification(true);
    } else {
      setShowBundleNotification(false);
    }
  }, [pageData?.bundleOfferSelected])

  const getTitleText = () => {
    const gridwallHeadings = metaInformation?.headings?.gridwall;
    if (isBogo) {
      return t("gridwall.bogo.heading");
    }
    if (!currentPath || !gridwallHeadings) return "";
    if (isOneTalk) {
      return "Business Desk Phones";
    } else if (is5gsmartphones) {
      return "Business 5G Smartphones";
    } else if (
      gridwallHeadings &&
      gridwallHeadings[currentPath] &&
      gridwallHeadings[currentPath]?.title
    ) {
      return gridwallHeadings[currentPath].title;
    } else if (
      gridwallHeadings[props.category] &&
      gridwallHeadings[props.category]?.title
    ) {
      return gridwallHeadings[props.category].title;
    } else if (
      gridwallHeadings[currentPath.split("/")[0]] &&
      gridwallHeadings[currentPath.split("/")[0]]?.title
    ) {
      return gridwallHeadings[currentPath.split("/")[0]].title;
    } else {
      return "Business Devices";
    }
  };

  return (
    <div className="gridwall-header" {...props}>
      {!enableBanner || currentPath.includes("free") ? (
        ""
      ) : (
        <GridWallHeaderContainer>
          <PromoHeader
            aemContent={gridWallBanner}
            isMobile={isMobile}
            isPortrait={isPortrait}
            isLaptop={isLaptop}
            isDesktop={isDesktopBanner}
            isTablet={isTablet}
            isLaptopByod={isLaptopByod}
          />
        </GridWallHeaderContainer>
      )}
      <VZStepper />
      <div className={isMobile ? "full-width" : "left-flex"}>
        {!hideBreadcrumbs && (
          <CustomBreadcrumb
            isProspect={true}
            is5gsmartphones={is5gsmartphones}
            isBogo={isBogo}
          />
        )}
      </div>
     
      {/* <div className="right-flex">
       { !landing4gData?.showHeroCopyForBundle ? <ContactSales
          showPhoneNumber={!isOneTalk}
          isMobile={isMobile}
          showCartDetailsModal={showCartDetailsModal}
          setshowCartDetailsModal={setshowCartDetailsModal}
        /> : <></>}
        {!isMobile && <ChatLink />}
      </div> */}
      {showBundleNotification && (
        <Notification
          type="info"
          title={t("gridwall.bundleNotification", { ns: "gridwall" })}
          fullBleed={true}
          inlineTreatment={false}
          className="notification"
        />
      )}
      {landing4gData?.showHeroCopyForBundle && <HeroCopy pageName="GW"></HeroCopy>}

      <div className={`${isDesktop ? "left-flex" : "full-width"} top-pad`} style={{ width: showBuyNowFlow ? '100%' : '' }}>
        <div className="gw-hr-ctn" >
        
        <TitleWrapper>
           <TitleLockup
              data={{
              eyebrow: {
              size: 'titleMedium',
              children: '',
              },
              title: {
              bold: false,
              size: 'titleXLarge',
              children: getTitleText(),
              }
              }}
        />
</TitleWrapper>


        </div>
        {isSearchLayout && showSearch && (
          <SearchInput
            value={searchValue}
            onChangeFn={(e) => setSearchValue(e.target.value)}
            onClickFn={() => fetchNextItems(1)}
            placeholderText={t("gridwall.labels.search-device")}
          />
        )}
      </div>
      {!isBogo && (

        <></>
      )}

      {!!isBogo && (
        <div className="full-width">
          <MarginSpacerM />
          <Text kind="body" size="large">{t("gridwall.bogo.subHeading")}</Text>
          <MarginSpacerM />
        </div>
      )}
    </div>
  );
};


export default GridwallHeader;
